export default {
  description: 'BTC PROP provides business partners with top services of property portfolio management. As the leading provider of these services on the Slovenian market, BTC PROP manages over 600,000 m2 of surfaces, while also offering maintenance and consultancy services to our business partners.',
  title: 'BTC Properties',
}